var map = {
	"./favicon.ico": 170,
	"./flags/en": 78,
	"./flags/en.svg": 78,
	"./flags/pl": 79,
	"./flags/pl.svg": 79,
	"./footer/en_ef": 80,
	"./footer/en_ef.svg": 80,
	"./footer/en_efs": 81,
	"./footer/en_efs.svg": 81,
	"./footer/en_rp": 82,
	"./footer/en_rp.svg": 82,
	"./footer/pl_ef": 83,
	"./footer/pl_ef.svg": 83,
	"./footer/pl_efs": 84,
	"./footer/pl_efs.svg": 84,
	"./footer/pl_rp": 85,
	"./footer/pl_rp.svg": 85,
	"./home_bg": 86,
	"./home_bg.jpg": 86,
	"./icons/clipboard": 87,
	"./icons/clipboard.svg": 87,
	"./icons/error": 88,
	"./icons/error.svg": 88,
	"./icons/eye_icon": 89,
	"./icons/eye_icon.svg": 89,
	"./icons/fa-sitemap": 90,
	"./icons/fa-sitemap.svg": 90,
	"./icons/facebook": 91,
	"./icons/facebook.svg": 91,
	"./icons/file_icon": 92,
	"./icons/file_icon.svg": 92,
	"./icons/gf-arrow_right-sharp": 93,
	"./icons/gf-arrow_right-sharp.svg": 93,
	"./icons/gf-mod-arrow_right-rounded": 94,
	"./icons/gf-mod-arrow_right-rounded.svg": 94,
	"./icons/gf-mod-chevron_right-rounded": 95,
	"./icons/gf-mod-chevron_right-rounded.svg": 95,
	"./icons/gf-mod-zoom_in-sharp": 96,
	"./icons/gf-mod-zoom_in-sharp.svg": 96,
	"./icons/gf-mod-zoom_out-sharp": 97,
	"./icons/gf-mod-zoom_out-sharp.svg": 97,
	"./icons/gf-query_stats-rounded": 98,
	"./icons/gf-query_stats-rounded.svg": 98,
	"./icons/lineup": 99,
	"./icons/lineup.svg": 99,
	"./icons/menu_blog": 100,
	"./icons/menu_blog.svg": 100,
	"./icons/menu_catalogs": 101,
	"./icons/menu_catalogs.svg": 101,
	"./icons/menu_museum": 102,
	"./icons/menu_museum.svg": 102,
	"./icons/menu_profile": 103,
	"./icons/menu_profile.svg": 103,
	"./icons/menu_timeline": 104,
	"./icons/menu_timeline.svg": 104,
	"./icons/resize_icon": 105,
	"./icons/resize_icon.svg": 105,
	"./icons/scan": 106,
	"./icons/scan.svg": 106,
	"./icons/search": 107,
	"./icons/search-grid": 108,
	"./icons/search-grid.svg": 108,
	"./icons/search-table": 109,
	"./icons/search-table.svg": 109,
	"./icons/search.svg": 107,
	"./icons/star_outline": 110,
	"./icons/star_outline.svg": 110,
	"./icons/table_resize": 111,
	"./icons/table_resize.svg": 111,
	"./icons/twitter": 112,
	"./icons/twitter.svg": 112,
	"./logo_en": 113,
	"./logo_en.svg": 113,
	"./logo_pl": 114,
	"./logo_pl.svg": 114,
	"./logo_text_en": 115,
	"./logo_text_en.svg": 115,
	"./logo_text_pl": 116,
	"./logo_text_pl.svg": 116,
	"./people_database": 117,
	"./people_database.jpg": 117,
	"./publication_database": 118,
	"./publication_database.jpg": 118,
	"./research_data": 119,
	"./research_data.jpg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 169;